module.exports = "//docs.gtimg.com/slide/img/img/closed-1x-41d6a9.png";